const themes = {
    london: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.7)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'none',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#173b45',
        '--layout-bg': '#061d50',
        '--sidebar-popup-bg': '#1d2a49',
        '--alpha-layout-bg': 'rgba(16,31,63,0.8)',
        '--queue-player-popup-bg': '#223c75',
        '--purple-primary': '#158370',
        '--link-text-hover': '#0daf94',
        '--sidebar-bg': 'rgba(0,0,0,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': '#111f3b',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#dadada',
        '--navigation-text': '#dadada',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.1)',
        'background-image': 'url("/images/bgThemes/London-Mid1.jpg")',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#1b2f5a,#182e5d)',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    xone: {
        '--mini-background-player': 'url("/images/miniBgThemes/xone-miniplayer.jpg")',
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.7)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'none',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#282828',
        '--layout-bg': '#1e1e1e',
        '--sidebar-popup-bg': '#292929',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#2d2f32',
        '--purple-primary': '#d7cb1f',
        '--link-text-hover': '#d7cb1f',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#d7cb1f',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#757575',
        '--navigation-text': '#a0a0a0',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.2)',
        'background-image': 'url("/images/bgThemes/xone-bg.jpg")',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    zing: {
        '--mini-background-player': 'url("/images/miniBgThemes/zma.png")',
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.2)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'none',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#4B1178',
        '--layout-bg': '#37075d',
        '--sidebar-popup-bg': '#572f90',
        '--alpha-layout-bg': 'rgba(16,31,63,0.8)',
        '--queue-player-popup-bg': '#5d218c',
        '--purple-primary': '#ed2b91',
        '--link-text-hover': '#fe63da',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#dadada',
        '--navigation-text': '#dadada',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.1)',
        'background-image': 'url("/images/bgThemes/theme1.svg")',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(to bottom, #740091, #2d1a4c)',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    eiffel: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.7)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'none',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#282828',
        '--layout-bg': '#1e1e1e',
        '--sidebar-popup-bg': '#292929',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#2d2f32',
        '--purple-primary': '#7200a1',
        '--link-text-hover': '#c662ef',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#757575',
        '--navigation-text': '#a0a0a0',
        '--song-item-action': 'hsla(0,0%,100%,0.5)',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.2)',
        'background-image': 'url("/images/bgThemes/theme2.jpg")',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    iu: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.3)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.5)',
        '--chart-bg-img-alpha': 'none',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#fffffe',
        '--layout-bg': '#e7dfdd',
        '--sidebar-popup-bg': '#f2f2f2',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#e5e3df',
        '--purple-primary': '#409abc',
        '--link-text-hover': '#8c8471',
        '--sidebar-bg': 'rgba(0,0,0,0.05)',
        '--alpha-bg': 'rgba(0,0,0,0.05)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'rgba(0,0,0,0.05)',
        '--loading-bg-animation': '#f5f5f5',
        '--scroll-thumb-bg': 'rgba(0,0,0,0.1)',
        '--no-content-bg': '#f9f9f9',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': '#d0ccc5',
        '--progressbar-player-bg': 'rgba(0,0,0,0.1)',
        '--progressbar-active-bg': 'var(--purple-primary)',
        '--text-primary': '#32323d',
        '--text-secondary': '#696969',
        '--text-item-hover': '#409abc',
        '--player-text': '#32323d',
        '--search-text': '#282828',
        '--text-placeholder': '#757575',
        '--navigation-text': '#32323d',
        '--border-primary': 'rgba(0,0,0,0.1)',
        '--border-secondary': 'rgba(0,0,0,0.05)',
        '--border-box': 'rgba(0,0,0,0.2)',
        '--border-player': 'rgba(0,0,0,0.05)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.08)',
        'background-image': 'url("/images/bgThemes/IU.jpg")',
        '--empty-album-icon': 'url("/images/empty/empty-album.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--empty-mv-icon': 'url("/images/empty/empty-mv.png")',
        '--img-logo': 'url("/images/logo/logo-light.svg")',
    },
    jiChangWook: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.3)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.5)',
        '--chart-bg-img-alpha': 'none',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#e1e8e8',
        '--layout-bg': '#b2d8db',
        '--sidebar-popup-bg': '#cce0e0',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#ced9d9',
        '--purple-primary': '#239292',
        '--link-text-hover': '#239292',
        '--sidebar-bg': 'hsla(0,0%,100%,0.3)',
        '--alpha-bg': 'hsla(0,0%,100%,0.3)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'rgba(0,0,0,0.05)',
        '--loading-bg-animation': '#f5f5f5',
        '--scroll-thumb-bg': 'rgba(0,0,0,0.1)',
        '--no-content-bg': '#f9f9f9',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': '#b4d0d0',
        '--progressbar-player-bg': 'rgba(0,0,0,0.1)',
        '--progressbar-active-bg': 'var(--purple-primary)',
        '--text-primary': '#32323d',
        '--text-secondary': '#696969',
        '--text-item-hover': '#239292',
        '--player-text': '#32323d',
        '--search-text': '#282828',
        '--text-placeholder': '#757575',
        '--navigation-text': '#32323d',
        '--border-primary': 'rgba(0,0,0,0.1)',
        '--border-secondary': 'rgba(0,0,0,0.05)',
        '--border-box': 'rgba(0,0,0,0.2)',
        '--border-player': 'rgba(0,0,0,0.05)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.08)',
        'background-image': 'url("/images/bgThemes/ji-chang-wook.jpg")',
        '--empty-album-icon': 'url("/images/empty/empty-album.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--empty-mv-icon': 'url("/images/empty/empty-mv.png")',
        '--img-logo': 'url("/images/logo/logo-light.svg")',
    },
    lisa: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.3)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.5)',
        '--chart-bg-img-alpha': 'none',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#fff8f8',
        '--layout-bg': '#f9dbdb',
        '--sidebar-popup-bg': '#fbd3d2',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#f9dbdb',
        '--purple-primary': '#ea7aa0',
        '--link-text-hover': '#ea7aa0',
        '--sidebar-bg': 'hsla(0,0%,100%,0.3)',
        '--alpha-bg': 'rgba(0,0,0,0.05)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'rgba(0,0,0,0.05)',
        '--loading-bg-animation': '#f5f5f5',
        '--scroll-thumb-bg': 'rgba(0,0,0,0.1)',
        '--no-content-bg': '#f9f9f9',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': '#f9c6c5',
        '--progressbar-player-bg': 'rgba(0,0,0,0.1)',
        '--progressbar-active-bg': 'var(--purple-primary)',
        '--text-primary': '#32323d',
        '--text-secondary': '#696969',
        '--text-item-hover': '#ea7aa0',
        '--player-text': '#32323d',
        '--search-text': '#282828',
        '--text-placeholder': '#757575',
        '--navigation-text': '#32323d',
        '--border-primary': 'rgba(0,0,0,0.1)',
        '--border-secondary': 'rgba(0,0,0,0.05)',
        '--border-box': 'rgba(0,0,0,0.2)',
        '--border-player': 'rgba(0,0,0,0.05)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.08)',
        'background-image': 'url("/images/bgThemes/lisa.jpg")',
        '--empty-album-icon': 'url("/images/empty/empty-album.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--empty-mv-icon': 'url("/images/empty/empty-mv.png")',
        '--img-logo': 'url("/images/logo/logo-light.svg")',
    },
    jennieKim: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.3)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.5)',
        '--chart-bg-img-alpha': 'none',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#e2e7f5',
        '--layout-bg': '#bab8c3',
        '--sidebar-popup-bg': '#f2f2f2',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#e5e3df',
        '--purple-primary': '#346875',
        '--link-text-hover': '#8c8471',
        '--sidebar-bg': 'rgba(0,0,0,0.05)',
        '--alpha-bg': 'rgba(0,0,0,0.05)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'rgba(0,0,0,0.05)',
        '--loading-bg-animation': 'rgba(0,0,0,0.05)',
        '--scroll-thumb-bg': 'rgba(0,0,0,0.1)',
        '--no-content-bg': '#f9f9f9',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': '#c6c4d1',
        '--progressbar-player-bg': 'rgba(0,0,0,0.1)',
        '--progressbar-active-bg': 'var(--purple-primary)',
        '--text-primary': '#32323d',
        '--text-secondary': '#696969',
        '--text-item-hover': '#2a5e6b',
        '--player-text': '#32323d',
        '--search-text': '#282828',
        '--text-placeholder': '#757575',
        '--navigation-text': '#32323d',
        '--border-primary': 'rgba(0,0,0,0.1)',
        '--border-secondary': 'rgba(0,0,0,0.05)',
        '--border-box': 'rgba(0,0,0,0.2)',
        '--border-player': 'rgba(0,0,0,0.05)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.08)',
        'background-image': 'url("/images/bgThemes/jennie.jpg")',
        '--empty-album-icon': 'url("/images/empty/empty-album.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--empty-mv-icon': 'url("/images/empty/empty-mv.png")',
        '--img-logo': 'url("/images/logo/logo-light.svg")',
    },
    jisoo: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.3)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.5)',
        '--chart-bg-img-alpha': 'none',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#fff',
        '--layout-bg': '#fff',
        '--sidebar-popup-bg': '#f2f2f2',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#fff',
        '--purple-primary': '#6b3483',
        '--link-text-hover': '#9c32ca',
        '--sidebar-bg': 'rgba(0,0,0,0.05)',
        '--alpha-bg': 'rgba(0,0,0,0.05)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'rgba(0,0,0,0.05)',
        '--loading-bg-animation': '#f5f5f5',
        '--scroll-thumb-bg': 'rgba(0,0,0,0.1)',
        '--no-content-bg': '#f9f9f9',
        '--tab-active-bg': '#fff',
        '--player-bg': '#fff',
        '--progressbar-player-bg': 'rgba(0,0,0,0.1)',
        '--progressbar-active-bg': 'var(--purple-primary)',
        '--text-primary': '#32323d',
        '--text-secondary': 'rgba(0,0,0,0.6)',
        '--text-item-hover': '#6b3483',
        '--player-text': '#32323d',
        '--search-text': '#282828',
        '--text-placeholder': '#757575',
        '--navigation-text': '#32323d',
        '--border-primary': 'rgba(0,0,0,0.1)',
        '--border-secondary': 'rgba(0,0,0,0.05)',
        '--border-box': 'rgba(0,0,0,0.2)',
        '--border-player': 'rgba(0,0,0,0.05)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.08)',
        'background-image': 'url("/images/bgThemes/jisoo.jpg")',
        '--empty-album-icon': 'url("/images/empty/empty-album.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--empty-mv-icon': 'url("/images/empty/empty-mv.png")',
        '--img-logo': 'url("/images/logo/logo-light.svg")',
    },
    rose: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.7)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'none',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#192f60',
        '--layout-bg': '#101f3f',
        '--sidebar-popup-bg': '#1d2a49',
        '--alpha-layout-bg': 'rgba(16,31,63,0.8)',
        '--queue-player-popup-bg': '#223c75',
        '--purple-primary': '#3460f5',
        '--link-text-hover': '#6e8ffb',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#dadada',
        '--navigation-text': '#dadada',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.1)',
        'background-image': 'url("/images/bgThemes/rose.jpg")',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#1b2f5a,#182e5d)',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    dark: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.7)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'rgba(30,30,30,0.9)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#282828',
        '--layout-bg': '#1e1e1e',
        '--sidebar-popup-bg': '#292929',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#2d2f32',
        '--purple-primary': '#7200a1',
        '--link-text-hover': '#c662ef',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#757575',
        '--navigation-text': '#a0a0a0',
        '--song-item-action': 'hsla(0,0%,100%,0.5)',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.2)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    purple: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.7)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'rgba(32,19,53,0.9)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#432275',
        '--layout-bg': '#170f23',
        '--sidebar-popup-bg': '#2a213a',
        '--alpha-layout-bg': 'rgba(41,21,71,0.8)',
        '--queue-player-popup-bg': '#120822',
        '--purple-primary': '#7200a1',
        '--link-text-hover': '#c662ef',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0, 0%, 100%, 0.15)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#dadada',
        '--navigation-text': '#dadada',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.1)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    blueLight: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.3)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'rgba(29,55,90,0.9)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#274a78',
        '--layout-bg': '#1d375a',
        '--sidebar-popup-bg': '#2a4162',
        '--alpha-layout-bg': 'rgba(29,55,90,0.8)',
        '--queue-player-popup-bg': '#0b274c',
        '--purple-primary': '#3460f5',
        '--link-text-hover': '#6e8ffb',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#dadada',
        '--navigation-text': '#dadada',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.1)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#1b2f5a,#182e5d)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-light.svg")',
    },
    green: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.7)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'rgba(18,69,52,0.9)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#126e54',
        '--layout-bg': '#124534',
        '--sidebar-popup-bg': '#244f3f',
        '--alpha-layout-bg': 'rgba(18,69,52,0.8)',
        '--queue-player-popup-bg': '#0c523a',
        '--purple-primary': '#309785',
        '--link-text-hover': '#309785',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#dadada',
        '--navigation-text': '#dadada',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.1)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#137555,#15533f)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    brown: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.7)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'rgba(87,64,59,0.9)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#6f514c',
        '--layout-bg': '#57403b',
        '--sidebar-popup-bg': '#604a45',
        '--alpha-layout-bg': 'rgba(87,64,59,0.8)',
        '--queue-player-popup-bg': '#63423c',
        '--purple-primary': '#986d5c',
        '--link-text-hover': '#d8987f',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#dadada',
        '--navigation-text': '#dadada',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.1)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#7b5e58,#654943)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    pink: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.7)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'rgba(142,51,122,0.9)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#a22687',
        '--layout-bg': '#800064',
        '--sidebar-popup-bg': '#883c6c',
        '--alpha-layout-bg': 'rgba(128,0,100,0.8)',
        '--queue-player-popup-bg': '#800064',
        '--purple-primary': '#d820b0',
        '--link-text-hover': '#fe63da',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#dadada',
        '--navigation-text': '#dadada',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.1)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#ad3994,#8f0f72)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    red: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.7)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.05)',
        '--chart-bg-img-alpha': 'rgba(115,23,23,0.9)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#883236',
        '--layout-bg': '#731717',
        '--sidebar-popup-bg': '#7a2922',
        '--alpha-layout-bg': 'rgba(115,23,23,0.8)',
        '--queue-player-popup-bg': '#561111',
        '--purple-primary': '#aa1c1c',
        '--link-text-hover': '#f36565',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'hsla(0,0%,100%,0.1)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'hsla(0,0%,100%,0.1)',
        '--loading-bg-animation': 'hsla(0,0%,100%,0.1)',
        '--scroll-thumb-bg': 'hsla(0,0%,100%,0.3)',
        '--no-content-bg': 'hsla(0,0%,100%,0.1)',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': 'rgba(0,0,0,0.2)',
        '--progressbar-player-bg': 'hsla(0,0%,100%,0.3)',
        '--progressbar-active-bg': '#fff',
        '--text-primary': '#fff',
        '--text-secondary': 'hsla(0,0%,100%,0.5)',
        '--text-item-hover': '#fff',
        '--player-text': '#fff',
        '--search-text': '#eee',
        '--text-placeholder': '#dadada',
        '--navigation-text': '#dadada',
        '--border-primary': 'hsla(0,0%,100%,0.1)',
        '--border-secondary': 'hsla(0,0%,100%,0.05)',
        '--border-box': 'hsla(0,0%,100%,0.2)',
        '--border-player': 'hsla(0,0%,100%,0.1)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.1)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album-dark.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty-dark.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song-dark.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload-dark.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#941c1c,#961919)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv-dark.png")',
        '--img-logo': 'url("/images/logo/logo-dark.svg")',
    },
    light: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.3)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.5)',
        '--chart-bg-img-alpha': 'hsla(0,0%,100%,0.9)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#fff',
        '--layout-bg': '#fff',
        '--sidebar-popup-bg': '#f2f2f2',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#fff',
        '--purple-primary': '#6b3483',
        '--link-text-hover': '#9c32ca',
        '--sidebar-bg': 'rgba(0,0,0,0.05)',
        '--alpha-bg': 'rgba(0,0,0,0.05)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'rgba(0,0,0,0.05)',
        '--loading-bg-animation': '#f5f5f5',
        '--scroll-thumb-bg': 'rgba(0,0,0,0.1)',
        '--no-content-bg': '#f9f9f9',
        '--tab-active-bg': '#fff',
        '--player-bg': '#fff',
        '--progressbar-player-bg': 'rgba(0,0,0,0.1)',
        '--progressbar-active-bg': 'var(--purple-primary)',
        '--text-primary': '#32323d',
        '--text-secondary': 'rgba(0,0,0,0.6)',
        '--text-item-hover': '#6b3483',
        '--player-text': '#32323d',
        '--search-text': '#282828',
        '--text-placeholder': '#757575',
        '--navigation-text': '#32323d',
        '--border-primary': 'rgba(0,0,0,0.1)',
        '--border-secondary': 'rgba(0,0,0,0.05)',
        '--border-box': 'rgba(0,0,0,0.2)',
        '--border-player': 'rgba(0,0,0,0.05)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.08)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv.png")',
        '--img-logo': 'url("/images/logo/logo-light.svg")',
    },
    gray: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.3)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.5)',
        '--chart-bg-img-alpha': 'rgb(229 227 223/90%)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#fffffe',
        '--layout-bg': '#e5e3df',
        '--sidebar-popup-bg': '#f2f2f2',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#e5e3df',
        '--purple-primary': '#8c8471',
        '--link-text-hover': '#8c8471',
        '--sidebar-bg': 'hsla(0,0%,100%,0.05)',
        '--alpha-bg': 'rgba(0,0,0,0.05)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'rgba(0,0,0,0.05)',
        '--loading-bg-animation': '#f5f5f5',
        '--scroll-thumb-bg': 'rgba(0,0,0,0.1)',
        '--no-content-bg': '#f9f9f9',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': '#d0ccc5',
        '--progressbar-player-bg': 'rgba(0,0,0,0.1)',
        '--progressbar-active-bg': 'var(--purple-primary)',
        '--text-primary': '#32323d',
        '--text-secondary': '#696969',
        '--text-item-hover': '#8c8471',
        '--player-text': '#32323d',
        '--search-text': '#282828',
        '--text-placeholder': '#757575',
        '--navigation-text': '#32323d',
        '--border-primary': 'rgba(0,0,0,0.1)',
        '--border-secondary': 'rgba(0,0,0,0.05)',
        '--border-box': 'rgba(0,0,0,0.2)',
        '--border-player': 'rgba(0,0,0,0.05)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.08)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv.png")',
        '--img-logo': 'url("/images/logo/logo-light.svg")',
    },
    greenLight: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.3)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.5)',
        '--chart-bg-img-alpha': 'rgb(206 217 217/0.9)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#e1e8e8',
        '--layout-bg': '#ced9d9',
        '--sidebar-popup-bg': '#cce0e0',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#ced9d9',
        '--purple-primary': '#239292',
        '--link-text-hover': '#239292',
        '--sidebar-bg': 'hsla(0,0%,100%,0.3)',
        '--alpha-bg': 'hsla(0,0%,100%,0.3)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'rgba(0,0,0,0.05)',
        '--loading-bg-animation': '#f5f5f5',
        '--scroll-thumb-bg': 'rgba(0,0,0,0.1)',
        '--no-content-bg': '#f9f9f9',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': '#b4d0d0',
        '--progressbar-player-bg': 'rgba(0,0,0,0.1)',
        '--progressbar-active-bg': 'var(--purple-primary)',
        '--text-primary': '#32323d',
        '--text-secondary': '#696969',
        '--text-item-hover': '#239292',
        '--player-text': '#32323d',
        '--search-text': '#282828',
        '--text-placeholder': '#757575',
        '--navigation-text': '#32323d',
        '--border-primary': 'rgba(0,0,0,0.1)',
        '--border-secondary': 'rgba(0,0,0,0.05)',
        '--border-box': 'rgba(0,0,0,0.2)',
        '--border-player': 'rgba(0,0,0,0.05)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.08)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv.png")',
        '--img-logo': 'url("/images/logo/logo-light.svg")',
    },
    pinkLight: {
        '--portal-menu-box-shadow': 'rgba(0,0,0,0.3)',
        '--chart-box-bg-alpha': 'hsla(0,0%,100%,0.5)',
        '--chart-bg-img-alpha': 'rgb(249 219 219/0.9)',
        '--hover-tooltip-opacity': 'hsla(0,0%,100%,0.3)',
        '--primary-bg': '#fff8f8',
        '--layout-bg': '#f9dbdb',
        '--sidebar-popup-bg': '#fbd3d2',
        '--alpha-layout-bg': 'rgba(12,3,3,0.8)',
        '--queue-player-popup-bg': '#f9dbdb',
        '--purple-primary': '#ea7aa0',
        '--link-text-hover': '#ea7aa0',
        '--sidebar-bg': 'hsla(0,0%,100%,0.3)',
        '--alpha-bg': 'rgba(0,0,0,0.05)',
        '--banner-home-dot': '#d8d8d8',
        '--loading-bg': 'rgba(0,0,0,0.05)',
        '--loading-bg-animation': '#f5f5f5',
        '--scroll-thumb-bg': 'rgba(0,0,0,0.1)',
        '--no-content-bg': '#f9f9f9',
        '--tab-active-bg': 'hsla(0,0%,100%,0.3)',
        '--player-bg': '#f9c6c5',
        '--progressbar-player-bg': 'rgba(0,0,0,0.1)',
        '--progressbar-active-bg': 'var(--purple-primary)',
        '--text-primary': '#32323d',
        '--text-secondary': '#696969',
        '--text-item-hover': '#ea7aa0',
        '--player-text': '#32323d',
        '--search-text': '#282828',
        '--text-placeholder': '#757575',
        '--navigation-text': '#32323d',
        '--border-primary': 'rgba(0,0,0,0.1)',
        '--border-secondary': 'rgba(0,0,0,0.05)',
        '--border-box': 'rgba(0,0,0,0.2)',
        '--border-player': 'rgba(0,0,0,0.05)',
        '--sticky-header-box-shadow': 'rgba(0,0,0,0.08)',
        'background-image': 'none',
        '--empty-album-icon': 'url("/images/empty/empty-album.png")',
        '--empty-podcast-icon': 'url("/images/empty/podcast-empty.png")',
        '--empty-song-icon': 'url("/images/empty/empty-fav-song.png")',
        '--empty-upload-icon': 'url("/images/empty/empty-upload.png")',
        '--linear-gradient-bg': 'linear-gradient(180deg,#740091,#2d1a4c)',
        '--has-week-chart-bg': 'url("/images/miniBgThemes/week-chart-bg.jpg")',
        '--empty-mv-icon': 'url("/images/empty/empty-mv.png")',
        '--img-logo': 'url("/images/logo/logo-light.svg")',
    },
};

export default themes;
